import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environment';
import {
  MfaChallengeAction,
  MfaInitiateOpts,
  MfaInitiateResponse,
  MfaValidateOpts,
  MfaValidateResponse,
} from '@interfaces';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MfaHttpService {
  private readonly http = inject(HttpClient);

  private API_URL = environment.API_URL;

  public initiateChallenge<TAction extends MfaChallengeAction>(
    opts: MfaInitiateOpts & { action: TAction }
  ): Observable<MfaInitiateResponse<TAction>> {
    const url = `${this.API_URL}/mfa/initiate`;
    return this.http.patch<MfaInitiateResponse<TAction>>(url, { ...opts });
  }

  public validateChallenge<TAction extends MfaChallengeAction>(
    opts: MfaValidateOpts & { action: TAction }
  ): Observable<MfaValidateResponse<TAction>> {
    const url = `${this.API_URL}/mfa/validate`;
    return this.http.patch<MfaValidateResponse<TAction>>(url, { ...opts });
  }
}
